__turbopack_context__.v({
  "disabled": "sectionItem-module-scss-module__19qMWG__disabled",
  "isActive": "sectionItem-module-scss-module__19qMWG__isActive",
  "item": "sectionItem-module-scss-module__19qMWG__item",
  "itemLink": "sectionItem-module-scss-module__19qMWG__itemLink",
  "itemText": "sectionItem-module-scss-module__19qMWG__itemText",
});
